import React from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'
import { Link } from 'react-router-dom'

const Wrapper = styled.button`
  border-radius: ${pxToRem('7px')};
  background-color: ${color.primary};
  border: 1px solid ${color.primary};
  padding: ${pxToRem('10')} ${pxToRem('20')};
  font-family: 'Open Sans', sans-serif;
  text-transform: uppercase;
  font-size: ${pxToRem('14px')};
  text-align: center;
  color: #ffffff;
  transition: .2s;
  cursor: pointer;
  ${props => props.full ? 'width: 100%;' : ''};
  &:hover,
  &:focus {
    box-shadow: 0 0 ${pxToRem('15px')} 0 ${color.secondary};
    outline: none;
  }
  &:active {
    box-shadow: inset 0 0 ${pxToRem('5px')} 0 ${color.secondary};
    border-color: ${color.secondary};
  }
  &:disabled {
    opacity: 0.5;  
    box-shadow: none;
    cursor: default;
  }
`

const ButtonWithLink = styled(Wrapper.withComponent(Link))`
  display: inline-block;
  text-decoration: none;
`

const ButtonLink = styled(Wrapper.withComponent('a'))`
  display: inline-block;
  text-decoration: none;
`

const Button = props => {
  const { children, routerLink = false, link = false, ...rest } = props;
  if(link) {
    return <ButtonLink {...rest}>{children}</ButtonLink>
  }
  return (
    routerLink ? (
      <ButtonWithLink {...rest} routerLink={routerLink}>{children}</ButtonWithLink>
    ) : (
        <Wrapper {...rest}>{children}</Wrapper>
      )
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Form/Button.js